import { createFileRoute } from "@tanstack/react-router";
import BeyondMedicationPage from "@/pages/learn/BeyondMedicationPage";
import { pageBeyondMedication } from "@/pages/learn/learnDataBeyondMedication";
export const Route = createFileRoute(
  "/learn/depression-treatment-without-more-medication",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Beyond More Medication | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Depression treatment beyond adding another medication: psychotherapy, TMS, SAINT®, and non-systemic approaches. Some patients may still use medication. Not.",
        },
        {
          property: "og:title",
          content:
            "Depression Treatment Beyond More Medication | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Depression treatment beyond adding another medication: psychotherapy, TMS, SAINT®, and non-systemic approaches. Some patients may still use medication. Not.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/depression-treatment-without-more-medication",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/depression-treatment-without-more-medication",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageBeyondMedication.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BeyondMedicationPage />;
}
